/**
 * react-router v6 → v7 opt-in flags.
 *
 * Without these, router 6.30 logs a deprecation warning on every mount,
 * which pollutes both the browser console and the test output. Opting in
 * early also keeps the eventual v7 upgrade uneventful.
 */
export const ROUTER_FUTURE_FLAGS = Object.freeze({
  v7_startTransition: true,
  v7_relativeSplatPath: true,
});
